<template>
  <div class="is-fluid">
    <div class="content-wrapper">
      <div class="box">
        <div class="card-content">
          <div class="content">
            <p>
              For better integration, please install our extension.<br>
              It's the fastest way to add bookmarks to your Qlipmark and it also integrates with your google searches, helping you get back to what you need very easily.<br>
              Install the extension and start adding bookmarks to your account.
            </p>

            <div class="columns">
              <div class="column is-6">
                <ul class="extension-install">
                  <li>
                    <b-button
                      tag="a"
                      type="is-primary"
                      size="is-large"
                      class="extension-link"
                      icon-pack="fab"
                      icon-left="chrome"
                      href="https://chrome.google.com/webstore/detail/qlipmark/abjbcfkcbbbemiffbfjjclakiimafgli"
                      target="_blank"
                    >
                      Chrome *
                    </b-button>
                  </li>
                  <li>
                    <b-button
                      tag="a"
                      disabled
                      type="is-primary"
                      size="is-large"
                      class="extension-link"
                      icon-pack="fab"
                      icon-left="firefox"
                    >
                      coming soon
                    </b-button>
                  </li>
                  <li>
                    <b-button
                      tag="a"
                      disabled
                      type="is-primary"
                      size="is-large"
                      class="extension-link"
                      icon-pack="fab"
                      icon-left="safari"
                    >
                      coming soon
                    </b-button>
                  </li>
                  <li>
                    <b-button
                      tag="a"
                      disabled
                      type="is-primary"
                      size="is-large"
                      class="extension-link"
                      icon-pack="fab"
                      icon-left="internet-explorer"
                    >
                      coming soon
                    </b-button>
                  </li>
                </ul>
                <p class="is-size-7">
                  * if you're getting a 404, it is due to being only available to the beta testers. Please login to your google account so you can access it.
                </p>
              </div>
              <div class="column is-6">
                <b-carousel>
                  <b-carousel-item
                    v-for="(carousel, i) in carousels"
                    :key="i"
                  >
                    <figure class="image">
                      <img :src="carousel.image">
                    </figure>
                  </b-carousel-item>
                </b-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="columns">
        <div class="column is-12">
          <div class="box">
            <div class="card-content">
              <div class="content">
                <div class="columns">
                  <div class="column is-6">
                    If you're using iOS, you can add a shortcut to your device so that you can bookmark through the share screen.
                  </div>
                  <div class="column is-6">
                    <b-button
                      tag="a"
                      type="is-primary"
                      size="is-medium"
                      icon-pack="fab"
                      icon-left="apple"
                      href="https://www.icloud.com/shortcuts/c0bab0c3195743adb2d00fe8adecd720"
                      class="extension-link"
                    >
                      iOS Shortcut
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="columns">
        <div class="column is-6">
          <div class="box">
            <div class="card-content">
              <div class="content">
                <div class="columns">
                  <div class="column is-6">
                    Alternatively, you can also drag this button to your browser “Bookmarks Bar” just to save things to Qlipmark.
                  </div>
                  <div class="column is-6">
                    <b-button
                      tag="a"
                      type="is-primary"
                      size="is-medium"
                      href="javascript:(function()%7Bwindow.open('http%3A%2F%2Fqlipmark.com%2Fbookmarks%2Fnew%2F%3Furl%3D'%2BencodeURI(window.location.href).replace('%23'%2C '%2523')%2C ''%2C 'width%3D600%2Cheight%3D500')%7D)()"
                      class="extension-link bookmarklet-button"
                    >
                      Add Bookmark
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-6">
          <div class="box">
            <div class="card-content">
              <div class="content">
                <div class="columns">
                  <div class="column is-6">
                    If you have used another bookmarking service or if you want to import your browsers bookmarks, you can do it here.
                  </div>
                  <div class="column is-6">
                    <b-button
                      tag="router-link"
                      to="/import"
                      type="is-primary"
                      size="is-medium"
                      class="extension-link"
                    >
                      Import
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="box">
        <div class="card-content">
          <div class="content">
            <p>Bug reports and notes, for now just <a href="mailto:filipe.pina@gmail.com">mail me.</a></p>

            <p>Thanks 🙏</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InfoPanel',
    data(){
      return {
        carousels: [
          { image: '/images/screenshots/app.jpg' },
          { image: '/images/screenshots/google.jpg' },
          { image: '/images/screenshots/popup.jpg' },
          { image: '/images/screenshots/popup_done.jpg' },
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .extension-install {
    margin: 0;
    padding: 0;
    list-style: none;
    max-width: 254px;
  }

  .bookmarklet-button {
    cursor: move;
  }

  .extension-link {
    width: 100%;
  }
</style>
